module.exports = __webpack_public_path__ + "public/Icons/5Storesettings.svg?755bd07c";